import { useState, memo, useMemo, useEffect } from "react"
import usePagination from "../../hooks/usePagination"
import ApiError from "../../components/ApiError"
import Dropdown from "../../components/Dropdown"
import { useAuditLogsData } from "../../hooks/useAuditLogs"
import { generateFilter } from "../../utils"
import { getDateRange } from "../../utils/datetime"
import AuditLogsTable from "../../components/AuditLogsTable"

const AuditLogs = () => {
  const { limit, onPaginationChange, page, pagination } = usePagination()
  const [filters, setFilters] = useState([])

  const getInitialValue = (key, defaultValue) => {
    const stored = sessionStorage.getItem("auditLogQueryObject")
    if (!stored) return defaultValue

    try {
      const parsed = JSON.parse(stored)
      return parsed[key] ?? defaultValue
    } catch (err) {
      return defaultValue
    }
  }

  const [date, setDate] = useState(getInitialValue("date", "Today"))
  const [filter, setFilter] = useState(getInitialValue("filter", "All"))
  const dateValues = useMemo(() => {
    if (date === "All") {
      return { startDate: "", endDate: "" }
    }
    const interval = getDateRange(date)
    return {
      startDate: interval.start.toISO(),
      endDate: interval.end.toISO(),
    }
  }, [date])

  const handleSetFilters = (newFilters) => {
    setFilters(newFilters)
  }

  const { data, isLoading, error, isError } = useAuditLogsData({
    page,
    limit,
    filters: {
      ...dateValues,
      filter,
      ...generateFilter(filters),
    },
  })

  useEffect(() => {
    const data = { date, filter }
    sessionStorage.setItem("auditLogQueryObject", JSON.stringify(data))
  }, [date, filter])

  if (isError) {
    return (
      <div className="mt-4">
        <ApiError axiosError={error} />
      </div>
    )
  }

  return (
    <div className="flex flex-col">
      <div className="px-1 flex justify-between items-center my-4 mx-4">
        <h1 className="font-medium text-xl text-primary">Audit Logs</h1>
        <div className="flex flex-row gap-6">
          <Dropdown
            label={"Filter Reports"}
            options={["All", "Failed"]}
            setValue={setFilter}
            value={filter}
          />
          <Dropdown
            label={"Date"}
            options={[
              "Today",
              "Yesterday",
              "This Week",
              "Last Week",
              "This Month",
              "Last Month",
            ]}
            setValue={setDate}
            value={date}
          />
        </div>
      </div>
      <div className="overflow-x-auto">
        <AuditLogsTable
          data={isLoading ? [] : data.data}
          filters={filters}
          loading={isLoading}
          pageCount={isLoading ? 0 : data.pages}
          pagination={pagination}
          query={{}}
          setFilters={handleSetFilters}
          onPaginationChange={onPaginationChange}
        />
      </div>
    </div>
  )
}

export default memo(AuditLogs)
